import React, { useState, useEffect } from 'react';
import { useSnackbar } from 'notistack';
import {
  Button,
  Typography,
  Toolbar,
  Dialog,
  Slide,
  IconButton,
  AppBar,
  Tooltip,
  ButtonGroup,
  Grid,
  Box,
  Modal,
  FormControlLabel,
  Autocomplete,
  TextField,
  Checkbox,
  Chip,
  Stack,
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
import RotateLeftIcon from '@mui/icons-material/RotateLeft';
import LoadingIcon from '../../../reusable-component/LoadingIcon';
import InputField from '../../../reusable-component/InputField';

const styleLoading = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
};

const nameRegex = /^[a-zA-Z0-9_]{1,35}$/;

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="left" ref={ref} {...props} />;
});

const INITIALSTATE = {
  alias: '',
  df: '',
  column_indices: [],
  sample_view: 'true',
};
const NodeModal_DeleteColumn = ({
  nodeId,
  nodeName,
  handleClose,
  open,
  nodes,
  edges,
  changeNodeName,
  setNodes,
  workflow,
}) => {
  const { enqueueSnackbar } = useSnackbar();
  const [formField, setFormField] = useState(INITIALSTATE);
  const [disableForm, setDisableForm] = useState(false);
  const [headerName, setHeaderName] = useState([]);
  const [fetchedHeader, setFetchedHeader] = useState([]);
  const [tempHeader, setTempHeader] = useState([]);
  const [inputValue, setInputValue] = useState('');
  const [headers, setHeaders] = useState([]);
  const [templateData, setTemplateData] = useState([]);
  const [editingKey, setEditingKey] = useState('');
  const [loading, setLoading] = useState(false);
  const [aliasError, setAliasError] = useState('');
  const [selectedColumn, setSelectedColumn] = useState(null);
  const [columnChips, setColumnChips] = useState([]);
  const [columnData, setColumnData] = useState([]);

  const [refreshModalOpen, setRefreshModalOpen] = useState(false);
  const handleRefreshModalOpen = () => setRefreshModalOpen(true);
  const handleRefreshModalClose = () => setRefreshModalOpen(false);

  const store = JSON.parse(sessionStorage.getItem('allNodes'));
  const [newHeader, setNewHeader] = useState([]);

  useEffect(() => {
    if (newHeader && newHeader.length > 0) {
      setColumnData(
        newHeader.map((el, idx) => ({
          index: idx,
          columnName: el.header,
        }))
      );
    }
  }, [newHeader]);

  const handleAddIndex = () => {
    const num = parseInt(inputValue, 10);
    if (num < 0 || num >= fetchedHeader.length) {
      enqueueSnackbar(`Index must be between 0 and ${fetchedHeader.length - 1}.`, {
        variant: 'error',
    
      });
      return;
    }
    if (!Number.isNaN(num) && !formField.column_indices.includes(num)) {
      setFormField({ ...formField, column_indices: [...formField.column_indices, num].sort((a, b) => b - a) });
    }
    if (formField.column_indices.includes(num)) {
      enqueueSnackbar(`Index : ${num} is already selected.`, {
        variant: 'error',
    
      });
      return;
    }
    setInputValue('');
  };

  const handleDeleteIndex = (index) => {
    setFormField({ ...formField, column_indices: formField.column_indices.filter((item) => item !== index) });
  };

  const getLocalData = async () => {
    const findSrcNodeId = [];
    edges.forEach((el) => {
      if (el.target === nodeId) {
        findSrcNodeId.push(el.source);
      }
    });

    if (store && findSrcNodeId) {
      let header = [];
      let prev_alias;
      let prev_nodeName;

      findSrcNodeId.forEach((item, i) => {
        store.forEach((node) => {
          if (node.nodeId === item) {
            header.push(...node.headerName);
            prev_alias = node.formField.alias;
            prev_nodeName = node.step_name;
          }
        });
      });
      setFormField({ ...formField, df: prev_alias });

      const newArr = [];

      if (prev_nodeName === 'Join') {
        header.forEach((el) => {
          const exist = el.header.split('.').length;

          if (exist === 2) {
            const head = el.header.split('.')[1];
            newArr.push({ ...el, header: el.alias ? el.alias : head });
          }
        });
      }
      if (newArr.length > 0) {
        header = newArr;
      }

      const uniqueHeader = [];

      const uniqueArray = header.filter((element) => {
        const isDuplicate = uniqueHeader.includes(element.header);

        if (!isDuplicate) {
          uniqueHeader.push(element.header);
          return true;
        }

        return false;
      });

      const builtHeader = uniqueArray.map((el) => {
        return {
          ...el,
          header: el.alias ? el.alias : el.header,
          alias: el.alias ? '' : el.alias,
        };
      });
      setNewHeader(builtHeader);

      const head = [];
      const coalesce = [];
      builtHeader.forEach((el) => {
        head.push({ label: el.header });
        coalesce.push({
          header: el.header,
          coalesce: [],
          alias: '',
          selected: false,
        });
      });

      setHeaders(head);
      setFetchedHeader(builtHeader);

      store.forEach((node) => {
        if (node.nodeId === nodeId) {
          setFormField(node.formField);
          setHeaderName(node.headerName);
          setTempHeader(node.headerName);
          if (node.disabled) {
            setDisableForm(node.disabled);
          }
        }
      });
    }
  };

  useEffect(() => {
    setFormField(INITIALSTATE);
    setDisableForm(false);
    setFetchedHeader([]);
    setHeaderName([]);
    getLocalData();
  }, [nodeId]);

  const refreshAllState = () => {
    handleRefreshModalOpen();

    let updateNodes = JSON.parse(sessionStorage.getItem('updatedNodes')) || [];

    let count = 0;

    setNodes((nds) =>
      nds.map((node) => {
        if (count <= updateNodes.length && node.id === updateNodes[count]) {
          node.position.x -= 0.1;
          count++;
        }

        return node;
      })
    );

    updateNodes = updateNodes.filter((el) => el !== nodeId);

    sessionStorage.setItem('updatedNodes', JSON.stringify(updateNodes));

    const findSrcNodeId = [];

    edges.forEach((el) => {
      if (el.target === nodeId) {
        findSrcNodeId.push(el.source);
      }
    });

    if (findSrcNodeId.length === 0) {
      setFormField(INITIALSTATE);
      setDisableForm(false);
      setFetchedHeader([]);
      setHeaderName([]);

      enqueueSnackbar('No source node is connected !!!', {
        variant: 'error',
    
      });
      handleRefreshModalClose();
      return;
    }

    let nodesExist = false;

    store.forEach((node) => {
      if (node.nodeId === nodeId) {
        nodesExist = true;
      }
    });

    if (store && findSrcNodeId) {
      let header = [];
      let prev_alias;
      let prev_nodeName;

      findSrcNodeId.forEach((item, i) => {
        store.forEach((node) => {
          if (node.nodeId === item) {
            header.push(...node.headerName);
            prev_alias = node.formField.alias;
            prev_nodeName = node.step_name;
          }
        });
      });

      setFormField({ ...formField, df: prev_alias });

      const newArr = [];

      if (prev_nodeName === 'Join') {
        header.forEach((el) => {
          const exist = el.header.split('.').length;

          if (exist === 2) {
            const head = el.header.split('.')[1];
            newArr.push({ ...el, header: el.alias ? el.alias : head });
          }
        });
      }

      if (newArr.length > 0) {
        header = newArr;
      }

      const uniqueHeader = [];

      const uniqueArray = header.filter((element) => {
        const isDuplicate = uniqueHeader.includes(element.header);

        if (!isDuplicate) {
          uniqueHeader.push(element.header);
          return true;
        }

        return false;
      });

      const builtHeader = uniqueArray.map((el) => ({
        ...el,
        header: el.alias ? el.alias : el.header,
        alias: el.alias ? '' : el.alias,
      }));
      setNewHeader(builtHeader);

      if (nodesExist) {
        store.forEach((node) => {
          if (node.nodeId === nodeId) {
            setFormField(node.formField);
            setHeaderName(node.headerName);

            const nonExistingHeader = [];
            node.fetchedHeader.forEach((item) => {
              const index = builtHeader.findIndex((x) => x.header === item.header);

              if (index !== -1) {
                nonExistingHeader.push(item);
              }
            });

            builtHeader.forEach((el) => {
              const index = nonExistingHeader.findIndex((x) => x.header === el.header);

              if (index === -1) {
                nonExistingHeader.push({
                  ...el,
                  header: el.alias ? el.alias : el.header,
                  alias: el.alias ? '' : el.alias,
                });
              }
            });

            const head = [];

            builtHeader.forEach((el) => {
              head.push({ label: el.header });
            });

            setHeaders(head);

            setFetchedHeader(nonExistingHeader);
          }
        });
      } else {
        setFetchedHeader(builtHeader);
      }
    }
    enqueueSnackbar('Data Refreshed!!!', {
      variant: 'Success',

    });
    handleRefreshModalClose();
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === 'alias') {
      if (value && !nameRegex.test(value)) {
        setAliasError('Special characters are not allowed');
      } else {
        setAliasError('');
      }
    }
    setFormField((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleResetForm = async () => {
    setFormField(INITIALSTATE);
  };

  const compareTwoArrayOfObjects = (first_array_of_objects, second_array_of_objects) => {
    return (
      first_array_of_objects.length === second_array_of_objects.length &&
      first_array_of_objects.every((element_1) =>
        second_array_of_objects.some(
          (element_2) =>
            element_1.header === element_2.header &&
            element_1.tableAlias === element_2.tableAlias &&
            element_1.alias === element_2.alias &&
            element_1.checked === element_2.checked
        )
      )
    );
  };

  const handleFormsubmit = async (e) => {
    e.preventDefault();

    if (!formField.column_indices || formField.column_indices.length === 0) {
    enqueueSnackbar('Please select at least one index before submitting.', {
      variant: 'warning',
    });
    return;
  }

    const updatedFetchedHeader = fetchedHeader
      .map((item, index) => ({ ...item, index }))
      .filter((item) => !formField.column_indices.includes(item.index));

    setFetchedHeader(updatedFetchedHeader);

    if (editingKey !== '') {
      enqueueSnackbar('One of the Editing is open', {
        variant: 'error',
    
      });
      return;
    }
    const getAllNodes = JSON.parse(sessionStorage.getItem('allNodes') || '[]');


    if (getAllNodes.length > 0) {
      const newFormData = getAllNodes.filter((el) => el.nodeId !== nodeId);
      sessionStorage.setItem('allNodes', JSON.stringify(newFormData));
    }

    let y_axis;

    nodes.forEach((el) => {
      if (nodeId === el.id) {
        y_axis = parseInt(el.position.x, 10);
        el.data.label = formField.alias;
      }
    });

    const newHeaderName = [
      ...templateData.map((item) => ({
        header: item.fieldname,
        column_indices: formField.column_indices,
        alias: '',
        checked: '',
        tableAlias: formField.alias,
      })),
    ];

    let equalArray;
    if (tempHeader.length > 0) {
      equalArray = compareTwoArrayOfObjects(tempHeader, headerName);
    }

    const connectedNodes = [];

    if (!equalArray && tempHeader.length > 0) {
      edges.forEach((el) => {
        if (el.source === nodeId) connectedNodes.push(el.target);
      });

      let count = 0;

      setNodes((nds) =>
        nds.map((node) => {
          if (count <= connectedNodes.length && node.id === connectedNodes[count]) {
            node.position.x += 0.1;
            count++;
          }

          return node;
        })
      );
    }

    sessionStorage.setItem('updatedNodes', JSON.stringify(connectedNodes));

    const sendFormData = {
      nodeId,
      nodeName,
      formField,
      disabled: true,
      step_name: nodeName,
      y_axis,
      headerName: updatedFetchedHeader,
      fetchedHeader: updatedFetchedHeader,
    };

    changeNodeName(nodes);

    setDisableForm(true);

    sessionStorage.setItem('node', JSON.stringify(nodes));
    sessionStorage.setItem('edges', JSON.stringify(edges));

    const fetchNodesData = JSON.parse(sessionStorage.getItem('allNodes') || '[]');
    fetchNodesData.push(sendFormData);

    sessionStorage.setItem('allNodes', JSON.stringify(fetchNodesData));

    const getElements = JSON.parse(sessionStorage.getItem('saved_node') || '[]');
    getElements.push(nodeId);
    sessionStorage.setItem('saved_node', JSON.stringify(getElements));
  };

  const handleEdit = (e) => {
    e.preventDefault();
    setDisableForm(false);
    store.forEach((node) => {
      if (node.nodeId === nodeId) {
        setTempHeader(headerName);
      }
    });

    const getAllNodes = JSON.parse(sessionStorage.getItem('allNodes'));

    getAllNodes.forEach((el) => {
      if (el.nodeId === nodeId) {
        el['disabled'] = false;
      }
    });

    sessionStorage.setItem('allNodes', JSON.stringify(getAllNodes));

    const getElements = JSON.parse(sessionStorage.getItem('saved_node'));

    const newSavedElement = getElements.filter((el) => el !== nodeId);

    sessionStorage.setItem('saved_node', JSON.stringify(newSavedElement));
  };

  const handleChecked = (event) => {
    setFormField({ ...formField, sample_view: event.target.checked });
  };
  const handleAutocompleteSelect = (event, newValue) => {
    if (newValue) {
      if (!formField.column_indices.includes(newValue.index)) {
        setFormField((prev) => ({
          ...prev,
          column_indices: [...prev.column_indices, newValue.index],
        }));
      }
      setSelectedColumn(null);
    }
  };
  useEffect(() => {
    const mappedChips = formField.column_indices.map((index) => {
      const column = columnData.find((col) => col.index === index);
      return column ? `${index}, ${column.columnName}` : `${index}`;
    });

    setColumnChips(mappedChips);
  }, [formField.column_indices, columnData]);

  return (
    <div>
      <Dialog fullScreen open={open} TransitionComponent={Transition} style={{ width: '70%', marginLeft: '30%' }}>
        <form autoComplete="off" onSubmit={handleFormsubmit}>
          <AppBar sx={{ position: 'relative', backgroundColor: '#fff' }}>
            <Toolbar>
              <IconButton edge="start" onClick={handleClose} aria-label="close" sx={{ color: '#00043C' }}>
                <CloseIcon />
              </IconButton>
              <Typography sx={{ ml: 2, flex: 1, color: '#00043C' }} variant="h6" component="div">
                {nodeName}
              </Typography>
              <Tooltip title="Refresh Schema" placement="left">
                <IconButton
                  disabled={disableForm}
                  edge="start"
                  onClick={refreshAllState}
                  aria-label="close"
                  sx={{ color: '#00043C' }}
                >
                  <RotateLeftIcon />
                </IconButton>
              </Tooltip>
              <ButtonGroup variant="contained" aria-label="outlined primary button group">
                <Button
                  size="small"
                  variant="outlined"
                  onClick={handleResetForm}
                  disabled={disableForm}
                  className="outlined-button-color"
                >
                  Clear
                </Button>
                <Button size="small" variant="outlined"  disabled={!disableForm} className="outlined-button-color" onClick={handleEdit}>
                  Edit
                </Button>
                <Button type="submit" size="small" variant="contained" disabled={disableForm} className="button-color">
                  Submit
                </Button>
              </ButtonGroup>
            </Toolbar>
          </AppBar>

          <div style={{ margin: '40px 20px 20px' }}>
            <Grid container spacing={2}>
              <Box sx={{ '& > :not(style)': { m: 2, width: '32ch' } }}>
                <InputField
                  name="alias"
                  label="Alias"
                  value={formField?.alias || ''}
                  onChange={handleInputChange}
                  size="small"
                  disabled={disableForm}
                  required
                  error={!!aliasError}
                  helperText={aliasError}
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      size="small"
                      checked={formField?.sample_view}
                      onChange={handleChecked}
                      disabled={disableForm}
                    />
                  }
                  label="Sample View"
                  sx={{ pl: 1 }}
                />
              </Box>
            </Grid>
            <Grid container spacing={2}>
              <Box sx={{ '& > :not(style)': { m: 2, width: '32ch' } }}>
                <Stack direction="row" alignItems="center" spacing={2}>
                  <Autocomplete
                    sx={{ width: '40ch' }}
                    options={columnData}
                    disabled={disableForm}
                    onChange={handleAutocompleteSelect}
                    getOptionLabel={(option) => `${option.columnName} (Index: ${option.index})`}
                    value={selectedColumn}
                    renderInput={(params) => <TextField {...params} label="Lookup Index by Column Name" size="small" />}
                  />
                </Stack>
                <Stack direction="row" alignItems="center" spacing={2} mt={2}>
                  <InputField
                    label="Enter Index"
                    size="small"
                    disabled={disableForm}
                    value={inputValue}
                    onChange={(e) => setInputValue(e.target.value.replace(/\D/, ''))}
                    onKeyPress={(e) => e.key === 'Enter' && handleAddIndex()}
                  />
                  <IconButton
                    sx={{ width: 40, height: 40 }}
                    disabled={disableForm}
                    color="primary"
                    onClick={handleAddIndex}
                  >
                    <AddIcon sx={{ fontSize: 24 }} />
                  </IconButton>
                </Stack>
                <Stack direction="row" spacing={1} m={2} flexWrap="wrap" gap={1}>
                  {columnChips.map((chip, idx) => (
                    <Chip
                      key={idx}
                      label={chip}
                      disabled={disableForm}
                      onDelete={() => handleDeleteIndex(formField.column_indices[idx])}
                      color="primary"
                    />
                  ))}
                </Stack>
              </Box>
            </Grid>
          </div>
        </form>
      </Dialog>
      <Modal open={refreshModalOpen} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
        <Box sx={styleLoading}>
          <LoadingIcon />
        </Box>
      </Modal>
    </div>
  );
};

export default NodeModal_DeleteColumn;
